module.exports = __webpack_public_path__ + "bf9cbc4f80e322112f234ec8c7d4a9a3.svg";